import comp from "./ChatAndChannelDualPannel.js";
export default comp;
